import React from 'react';
import {connect} from 'react-redux';
import {push} from 'connected-react-router';
import {SMCSelect, SMCOption} from '../../Simple/SMCSelect';
import i18n from '../../../i18n';
import './index.css';
import 'simplebar/dist/simplebar.min.css';
import CPLogo from './CPLogo';
import {Grid, Button} from '@mui/material';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {useTranslation} from 'react-i18next';
import DomainSelector from './DomainSelector';
import config from '../../../conf/config';
import {userRoleNameSelector, userIdSelector, currentPortalSelector, isEmptyPortalSelector} from '../../../store/selectors/user.selectors';
import {SMCPaths, getHelpURL, helpContextPageUrl} from '../../../conf/Routes';
import {useWindowDimensions} from '../../../utils/hooks';
import SimpleBar from 'simplebar-react';
import SMCLink from '../../Simple/SMCLink';
import {Link} from 'react-router-dom';
import GlobalGatewaySearch from './GlobalGatewaySearch';

const Sepperator = () => <span style={{ color: 'white' }}>|</span>;
const GridSepperator = () => <Grid item><Sepperator /></Grid>;

const mainHeaderLogoContainerWidth = 210;

function SMPMainHeader({
    navigateTo,
    userRoleName,
    userId,
    currentPortal,
    isEmptyPortal
}) {
   
    const { t } = useTranslation();
    const { windowWidth } = useWindowDimensions();
    const controlsWidth = windowWidth - mainHeaderLogoContainerWidth - 15;
    
    const headerLogoOnClick = () => {
        if (isEmptyPortal) {
            navigateTo(SMCPaths.systemSettings);
        } else {
            navigateTo(SMCPaths.home); // Home only exists on non-empty domain (meanwhile...)
        }
    }


    return (
        <div className="SMCMainHeader">
            {/* Left float */}
            <div className="SMCMainHeaderLogoContainer" onClick={headerLogoOnClick}>
                <CPLogo />
            </div>
            {/* Right float */}
            <div style={{ float: 'right', height: '100%', width: controlsWidth, overflowX: 'auto', overflowY: 'hidden' }}>
                <SimpleBar>
                    <Grid container direction="row" justify="flex-end" alignItems="center" wrap="nowrap" spacing={1} style={{ height: '100%', width: 'fit-content', paddingTop: '9px', paddingBottom: '10px', overflow: 'hidden', marginLeft: 'auto', marginRight: 'unset' }}>
                        <Grid item>
                            <DomainSelector currentDomain={currentPortal} />
                        </Grid>
                        <GridSepperator />
                        <Grid item>
                                <div style={{ whiteSpace: 'nowrap' }}>
                                    <FontAwesomeIcon color="#e8f1ff" size="sm" icon="user" />
                                    <Link style={{ color: 'white', fontSize: '13px', padding: '0px 13px', textDecoration: 'none' }} to={SMCPaths.genericUser+'?id='+userId}>{userId} ({userRoleName})</Link>
                                </div>
                        </Grid>
                        <GridSepperator />
                        {
                            // Language select, for development mode only
                            config.development_mode && (
                                <>
                                <Grid item>
                                    <SMCSelect
                                        inline
                                        width="auto"
                                        className="languageSelect"
                                        onChange={e => i18n.changeLanguage(e.target.value) }
                                    >
                                        <SMCOption value="en" className="languageSelectOption">English</SMCOption>
                                        <SMCOption value="ja" className="languageSelectOption">Japanese</SMCOption>
                                        <SMCOption value="fr" className="languageSelectOption">French</SMCOption>
                                        <SMCOption value="de" className="languageSelectOption">German</SMCOption>
                                    </SMCSelect>
                                </Grid>
                                <GridSepperator />
                                </>
                            )
                        }
                        <Grid item>
                            <SMCLink openInNewTab href={getHelpURL(helpContextPageUrl.general)}>
                            <Button style={{ color: "#fff", fontSize: '13px', background: 'none', border: 'none', margin: 0, padding: 0 }}>
                                <FontAwesomeIcon icon="question-circle" style={{ width: 16, height: 16 }} />
                                <span style={{ paddingLeft: '5px' }}>{t("SMC_HEADER_HELP")}</span>
                            </Button>
                        </SMCLink>   
                        </Grid>
                        <GridSepperator />
                        <Grid item>
                            <Button style={{ color: "#fff", fontSize: '13px', background: 'none', border: 'none' }} onClick={() => navigateTo(SMCPaths.logout)}>
                                <FontAwesomeIcon icon="sign-out-alt" />
                                <span style={{ paddingLeft: '5px' }}>{t("SMC_HEADER_LOGOUT")}</span>
                            </Button>
                        </Grid>
                        {
                            !isEmptyPortal && (
                                <Grid item>
                                    <GlobalGatewaySearch currentPortal={currentPortal} />
                                </Grid>
                            )
                        }                        
                    </Grid>
                </SimpleBar>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    userRoleName: userRoleNameSelector(state),
    userId: userIdSelector(state),
    currentPortal: currentPortalSelector(state),
    isEmptyPortal: isEmptyPortalSelector(state)
});

const mapDispatchToProps = {
    navigateTo: push
}

export default connect(mapStateToProps, mapDispatchToProps)(SMPMainHeader);